import React from 'react';
import footerBackground from '../images/bg-footer.jpg';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import logo from '../images/stephmens-logo.png';

const Footer = () => {
    return (
        <footer className='w-full bg-cover bg-center bg-no-repeat text-white h-full' style={{ backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${footerBackground})` }}>
            <div className='md:min-w-full bg-blue-900 bg-opacity-50 p-5'>
                <img className=' w-[150px] h-[150px] bg-white rounded-full mx-auto' src={logo} alt="company-logo" />
            </div>



            <div className='lg:flex  lg:flex-row flex-col justify-between bg-blue-900 bg-opacity-50 lg:px-24'>

                <div className='p-4 md:w-[250px]'>
                    <h2 className='text-yellow-400 font-bold text-xl '>Quick Links</h2>
                    <ul className='text-white text-[18px]'>
                        <li><a href="/.">Home</a></li>
                        <li><a href="/.">About</a></li>
                        <li><a href="/.">Services</a></li>
                        <li><a href="/.">Our Works</a></li>
                        <li><a href="/.">Gallery</a></li>
                        <li><a href="/.">Contacts</a></li>
                    </ul>
                </div>
                <div className='p-4 md:w-[300px]'>
                    <h2 className='text-yellow-400 font-bold text-xl'>IT Support Services</h2>
                    <ul className='text-white text-[18px]'>
                        <li><a href="/.">Computer Repair</a></li>
                        <li><a href="/.">Operating System Configuration</a></li>
                        <li><a href="/.">Windows & Linux installation</a></li>
                        <li><a href="/.">Network Setup</a></li>
                        <li><a href="/.">Software Installation</a></li>
                        <li><a href="/.">Virus Removal</a></li>
                        <li><a href="/.">Data Recovery</a></li>
                    </ul>
                </div>
                <div className='p-4 md:w-[300px]'>
                    <h2 className='text-yellow-400 font-bold text-xl'>Printing Press Services</h2>
                    <ul className='text-white text-[18px]'>
                        <li><a href="/.">Digital Sign Board & Installation</a></li>
                        <li><a href="/.">General Printing</a></li>
                        <li><a href="/.">DTF Printing</a></li>
                        <li><a href="/.">Customization T-Shirts</a></li>
                        <li><a href="/.">Invitation Cards, Brochures & Magazines</a></li>
                        <li><a href="/.">Invoice, Receipt & Way Bill</a></li>
                        <li><a href="/.">Bill Boards, 3D & 2D & Installation</a></li>
                        <li><a href="/.">Picture Frames</a></li>
                    </ul>
                </div>
                <div className='w-full p-4 md:w-[300px] '>
                    <h2 className='text-yellow-400 font-bold text-xl mb-2'>Contacts & Address</h2>
                    <div className='flex items-center mb-2'>
                        <LocationOnIcon className="text-yellow-400 mr-2" />
                        <p>New Onyinase - Tako, Behind Bel Acqua Distribution Company.</p>
                    </div>
                    <div className='flex items-center mb-2'>
                        <PhoneIcon className="text-yellow-400 mr-2" />
                        <p><a href="tel:+233598946885">059 894 6885</a></p>
                    </div>
                    <div className='flex items-center mr-5'>
                        <EmailIcon className="text-yellow-400 mr-2" />
                        <p> <a href="mailto:stephmenssuppertech@gmail.com">stephmenssuppertech@gmail.com</a>.</p>
                    </div>
                </div>

            </div>
            <div className='text-center bg-blue-900 bg-opacity-50 p-4'>
                <p>&copy; 2023 Stephmens Supertech. All rights reserved.</p>
            </div>

        </footer>
    );
};

export default Footer;